import {
  TIMEPICKER_SIZE_CONFIG,
  clampTimePart,
  formatTimeDisplay,
  formatTimeValue,
  parseTimeValue,
  type STimePickerMeridiem,
  type STimePickerSize,
  type STimePickerType,
} from '../STimePicker/timepicker.config';

export type STimeRangePickerSize = STimePickerSize;
export type STimeRangePickerType = STimePickerType;
export type STimeRangePickerMeridiem = STimePickerMeridiem;
export type STimeRangePickerRangeOrder = 'strict' | 'allow-cross-day';
export type STimeRangeValue = [string, string] | null;

export {
  TIMEPICKER_SIZE_CONFIG as TIME_RANGE_PICKER_SIZE_CONFIG,
  clampTimePart,
  formatTimeDisplay,
  formatTimeValue,
  parseTimeValue,
};

function getTimeMinutes(value: string): number {
  const { hour, minute } = parseTimeValue(value);
  return hour * 60 + minute;
}

export function normalizeTimeRangeValue(
  value: STimeRangeValue,
  rangeOrder: STimeRangePickerRangeOrder = 'strict',
): STimeRangeValue {
  if (value == null) return null;
  const normalized = value.map(item => {
    const parsed = parseTimeValue(item);
    return formatTimeValue(parsed.hour, parsed.minute);
  }) as [string, string];

  if (rangeOrder === 'strict' && getTimeMinutes(normalized[0]) > getTimeMinutes(normalized[1])) {
    return [normalized[0], normalized[0]];
  }

  return normalized;
}

export function formatTimeRangeDisplay(value: STimeRangeValue, type: STimeRangePickerType): string {
  if (value == null || value[0] === '' || value[1] === '') return '';
  return `${formatTimeDisplay(value[0], type)} ~ ${formatTimeDisplay(value[1], type)}`;
}
